import React from 'react';
import cn from 'classnames';
import { bbCodeToHtml } from '../../../../../../../utils/formUtils';
import { random } from '../../../../../../../utils/utils';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';

interface Props {
  id?: string;
  value?: string[][];
  visibility?: Visibility;
}

const renderRow = (row: string[]) => {
  return (
    <div styleName="table__row" key={random()}>
      {row.map(value => (
        <div
          key={value || random()}
          styleName="table__cell"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: bbCodeToHtml(value),
          }}
        />
      ))}
    </div>
  );
};

const Table: React.FC<Props> = ({ id, visibility, value = [] }) => {
  if (!value.length) return null;
  return (
    <div
      id={id}
      data-cy="table"
      styleName={cn('table', {
        hidden: visibility === Visibility.Hidden,
      })}
    >
      <div styleName="table__body">{value.map(row => renderRow(row))}</div>
    </div>
  );
};
export default Table;
